import {
	TypedUseSelectorHook,
	useSelector as useSelectorRedux,
} from 'react-redux';

export const makeUseSelector = <State>(): TypedUseSelectorHook<State> => {
	return useSelectorRedux;
};
